import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { ContactListItem } from '../models/contact-list-item';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';

export const CONTACT_LIST_FETCH = 'CONTACT_LIST_FETCH';
export const CONTACT_LIST_RECEIVE = 'CONTACT_LIST_RECEIVE';
export const CONTACT_LIST_FETCH_FAILED = 'CONTACT_LIST_FETCH_FAILED';

export const receiveContactList = (contacts: PaginatedResponse<ContactListItem>) => {
    return {
        type: CONTACT_LIST_RECEIVE,
        contacts,
    };
};

export const fetchContactList = (searchParams: URLSearchParams) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CONTACT_LIST_FETCH });
        const response = await api.contactsAndOrganizations.Contact.ContactList.getContacts(searchParams);
        if (response.success) {
            dispatch(receiveContactList(response.result));
        } else {
            dispatch({ type: CONTACT_LIST_FETCH_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
